module.exports = __webpack_public_path__ + "static/media/img_2.b7eb893d.png";